import { combineReducers } from "redux";
import { walletConnectorSlice } from "../components/common/wallet-authentication/redux/walletAuthenticationSlice";
import { crucibleSlice } from "../components/crucible/redux/CrucibleSlice";
import { vestingSlice } from "../components/vesting/redux/VestingSlice";
// slices
import {
  competitionReducer,
  leaderboardReducer,
  phraseReducer,
  walletReducer,
  contractReducer,
  networkReducer,
  swapReducer,
  liquidityReducer,
  configReducer,
} from "./slices";
import { approvableButtonSlice } from "../container-components/web3Client/approvalButtonWrapper";
import { chainEventsSlice } from "../container-components/web3Client/chainEventItem";
import persistReducer from "redux-persist/es/persistReducer";
import storageSession from "redux-persist/lib/storage/session";
import localStorage from "redux-persist/es/storage";
// import { myTradesSlice } from "./my-trades/myTradesSlice";
// import { applicationConfigSlice } from "./application-config/applicationConfigSlice";

// const walletApplicationWrapperPersistConfig = {
//   key: "walletApplicationWrapper",
//   storage: localStorage,
//   whitelist: ["tokenList" ],
//   timeout: 172800,
// };

const cruciblePersistConfig = {
  key: "crucible",
  storage: localStorage,
  blacklist: ["tokenData"],
  // whitelist: [ "stepFlowStepHistory", "currentStep", "currentStepIndex"]
};

const vestingPersistConfig = {
  key: "vesting",
  storage: localStorage,
};

const walletAutheticatorPersistConfig = {
  key: "walletAutheticator",
  storage: storageSession,
  whitelist: ["meV2", "tokenV2"],
};

const networkPersistConfig = {
  key: "network",
  storage: storageSession,
  whitelist: ["selectedNetwork", "networksPayload"],
};

const walletPersistConfig = {
  key: "wallet",
  storage: storageSession,
  whitelist: ["selectedWallet", "walletsPayload"],
};

const appPersistConfig = {
  key: "config",
  storage: storageSession,
  whitelist: ["theme"],
};

const swapTokensPersistConfig = {
  key: "swap",
  storage: localStorage,
  whitelist: ["allTokens", "versionHistory"],
};

const rootReducer = combineReducers({
  walletAuthenticator: persistReducer(
    walletAutheticatorPersistConfig,
    walletConnectorSlice.reducer
  ),
  approval: approvableButtonSlice.reducer,
  watchEvents: chainEventsSlice.reducer,
  phrase: phraseReducer,
  contract: contractReducer,
  liquidity: liquidityReducer,
  competition: competitionReducer,
  leaderboard: leaderboardReducer,
  config: persistReducer(appPersistConfig, configReducer),
  swap: persistReducer(swapTokensPersistConfig, swapReducer),
  wallets: persistReducer(walletPersistConfig, walletReducer),
  networks: persistReducer(networkPersistConfig, networkReducer),
  vesting: persistReducer(vestingPersistConfig, vestingSlice.reducer),
  crucible: persistReducer(cruciblePersistConfig, crucibleSlice.reducer),

  // swap: swapReducer,
  // swap: persistReducer(swapPersistConfig, swapReducer),
  // networks: netwoårkReducer,
  // applicationConfig: applicationConfigSlice.reducer,
  // myTradesTransactions: myTradesSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
